import AuthService from './AuthService';
import ApiService from './ApiService';

class DashboardService extends ApiService {
    constructor(authService) {
        super();

        this._authService = authService;
        this._locale = 'ru';
        this._dashboardUrl = '/dashboard';
    }

    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization': this._locale} : {};
        const authHeader = this._authService.getAuthHeader();

        return {...authHeader, ...langHeader};
    }

    getDashboard() {
        return this.postResource(this._dashboardUrl, {}, this.getBaseHeaders());
    }
}

const service = new DashboardService(AuthService);

export default service;
